import { isArray } from "lodash";
import { composeFunnelbackSortParam } from "../components/SearchResultsTable/formatSortOrder";
import isFacetSearchParam from "../components/SearchForm/isFacetSearchParam";
import {
    SearchCollectionConfig,
    SearchFilters,
    SearchResultsSort,
} from "../types/context";
import { FunnelbackResponse } from "../types/funnelback";
import isRangeSearchParam from "../components/SearchForm/isRangeSearchParam";

export interface FetchDataArgs {
    query?: string;
    params?: SearchFilters;
    offset?: number;
    sort?: SearchResultsSort;
    config: SearchCollectionConfig;
}

export const fetchData = async ({
    query = "!showall",
    params = {},
    offset = 1,
    sort = { field: "", direction: "none" },
    config,
}: FetchDataArgs) => {
    const { endpoint, collection, profile, perPage } = config;
    const url = new URL(endpoint);
    const fetchSearchParams = url.searchParams;

    fetchSearchParams.append("collection", collection);
    fetchSearchParams.append("profile", profile);
    fetchSearchParams.append("query", query);
    // functional requirement for ministerial permits
    if (
        collection === "delwp-planning-ministerial-permits-stage" ||
        collection === "delwp-planning-ministerial-permits-prod"
    ) {
        fetchSearchParams.append(
            "meta_applicationType_not",
            `"Application to Correct Planning Permit"`
        );
    }
    fetchSearchParams.append("num_ranks", (perPage || 10).toString());

    if (offset && !isNaN(offset)) {
        fetchSearchParams.append("start_rank", offset.toString());
    }

    const sortParamValue = composeFunnelbackSortParam(sort);
    if (sortParamValue) {
        fetchSearchParams.set("sort", sortParamValue);
    } else {
        fetchSearchParams.delete("sort");
    }

    // Set Funnelback facet URL search params
    Object.entries(params).forEach(([paramKey, paramValue]) => {
        const isRangeKey = isRangeSearchParam(paramKey);

        if (!isFacetSearchParam(paramKey) && !isRangeKey) {
            return;
        }

        if (isRangeKey) {
            // Remove suffixes for range values
            paramKey = paramKey.replace(/(\|\w*)(__start$|__end$)/, "");
            paramValue = (<string>paramValue).replaceAll("-", "");
        }

        if (isArray(paramValue)) {
            paramValue.forEach((option) => {
                fetchSearchParams.append(paramKey, option);
            });
        } else {
            fetchSearchParams.set(paramKey, paramValue);
        }
    });

    const response = await fetch(url.href);
    const data: FunnelbackResponse = await response.json();
    return data;
};
